import { ExtendedUserProfile, UserProfile } from './types';

export const STATIC_USER_PROFILE: UserProfile = {
  role_id: 44,
  company_size_id: 3,
  organization_name: 'Zapier',
  inferred_organization_name: 'Zapier',
};

export const STATIC_EXTENDED_USER_PROFILE: ExtendedUserProfile = {
  ...STATIC_USER_PROFILE,
  role_name: 'Engineering',
  company_size_display_range: '250-999',
};

export const DEFAULT_EXTENDED_USER_PROFILE: ExtendedUserProfile = {
  role_id: null,
  role_name: '',
  company_size_id: null,
  company_size_display_range: '',
  organization_name: '',
  inferred_organization_name: '',
};
